export default "__VITE_ASSET__mhIO39$N__"